import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { NoContentComponent } from './no-content/no-content.component';

const appRoutes: Routes = [
  { path: '',      component: HomeComponent, pathMatch: 'full' },
  { path: 'home',  component: HomeComponent },
  { path: 'private', loadChildren: './private#PrivateModule'},
  { path: '**',    component: NoContentComponent },
];
@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { useHash: true, preloadingStrategy: PreloadAllModules })
  ],
  declarations: [],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts